var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHowItWorksArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 60,
    height: 1.5,
    rx: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    width: 8,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(45 55 0)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.657,
    y: 5.657,
    width: 8,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(135 60.657 5.657)"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjEiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCA2MSAxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iNSIgd2lkdGg9IjYwIiBoZWlnaHQ9IjEuNSIgcng9IjAuNzUiIC8+CjxyZWN0IHg9IjU1IiB3aWR0aD0iOCIgaGVpZ2h0PSIxLjUiIHJ4PSIwLjc1IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSA1NSAwKSIgLz4KPHJlY3QgeD0iNjAuNjU2OSIgeT0iNS42NTY4NiIgd2lkdGg9IjgiIGhlaWdodD0iMS41IiByeD0iMC43NSIgdHJhbnNmb3JtPSJyb3RhdGUoMTM1IDYwLjY1NjkgNS42NTY4NikiIC8+Cjwvc3ZnPgo=";
export { SvgHowItWorksArrow as ReactComponent };